import React from 'react';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';

const CheckCircle = (props) => <CheckCircleIcon {...props} />;

export default CheckCircle;
